export default "__VITE_ASSET__Y5JD$qbb__"